import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { f7 } from 'framework7-react';
import { LOAD_DISCOVER } from '../store/actions/discover';
import { GOOGLE_MAP } from '../config/fbConfig';
import useGeoCode from '../utils/geoCode';

class MapContainer extends React.Component {
  constructor(props) {
    super(props);

    this.mapLightMode = [
      {
        elementType: 'labels.icon',
        stylers: [
          {
            color: '#654236',
          },
          {
            visibility: 'off',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#f5f5f5',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#bdbdbd',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'poi.business',
        elementType: 'labels.icon',
        stylers: [
          {
            color: '#654236',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#6fe7a1',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#757575',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#dadada',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#616161',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9e9e9e',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [
          {
            color: '#e5e5e5',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#eeeeee',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#6fc8eb',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#ffffff',
          },
        ],
      },
    ];

    this.mapDarkMode = [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#242f3e',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#746855',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#242f3e',
          },
        ],
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#d59563',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#ffeb3b',
          },
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#d59563',
          },
        ],
      },
      {
        featureType: 'poi.business',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'on',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry',
        stylers: [
          {
            color: '#263c3f',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#6b9a76',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#38414e',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#212a37',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#9ca5b3',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#746855',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#1f2835',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#f3d19c',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'geometry',
        stylers: [
          {
            color: '#2f3948',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#d59563',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#17263c',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#515c6d',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#17263c',
          },
        ],
      },
    ];

    this.mapStyle =
      localStorage.mapDarkMode == 'true' ? this.mapDarkMode : this.mapLightMode;
  }

  fetchPlaces(mapProps, map) {
    const self = this;
    const { google } = mapProps;
    self.props.updateState({
      service: new google.maps.places.PlacesService(map),
    });

    map.setOptions({
      styles: this.mapStyle,
    });
  }

  moveMarker(props, marker, e) {
    const self = this;
    self.props.dispatch({
      type: LOAD_DISCOVER,
      payload: {
        geoLoc: {
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        },
      },
    });

    useGeoCode(
      {
        type: 'Address',
        data: {
          lat: marker.position.lat(),
          lng: marker.position.lng(),
        },
      },
      (error, address) => {
        if (error) {
          self.props.updateState({
            deliveryAddress: '',
            disableButton: false,
          });
          return self.props.dispatch({
            type: LOAD_DISCOVER,
            payload: {
              deliveryAddress: '',
            },
          });
        }

        self.props.updateState({
          deliveryAddress: address,
          disableButton: false,
        });

        self.props.dispatch({
          type: LOAD_DISCOVER,
          payload: {
            deliveryAddress: address,
          },
        });

        const lastLocation = {
          deliveryAddress: address,
          geoLoc: {
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          },
        };

        self.props.saveLocation(lastLocation);
      }
    );
  }

  onMapClicked(mapProps, map, clickEvent) {
    const self = this;
    self.props.dispatch({
      type: LOAD_DISCOVER,
      payload: {
        geoLoc: {
          lat: clickEvent.latLng.lat(),
          lng: clickEvent.latLng.lng(),
        },
      },
    });

    useGeoCode(
      {
        type: 'Address',
        data: {
          lat: clickEvent.latLng.lat(),
          lng: clickEvent.latLng.lng(),
        },
      },
      (error, address) => {
        if (error) {
          self.props.updateState({
            deliveryAddress: '',
            disableButton: false,
          });
          return self.props.dispatch({
            type: LOAD_DISCOVER,
            payload: {
              deliveryAddress: '',
            },
          });
        }

        self.props.updateState({
          deliveryAddress: address,
          disableButton: false,
        });

        self.props.dispatch({
          type: LOAD_DISCOVER,
          payload: {
            deliveryAddress: address,
          },
        });

        const lastLocation = {
          deliveryAddress: address,
          geoLoc: {
            lat: clickEvent.latLng.lat(),
            lng: clickEvent.latLng.lng(),
          },
        };

        self.props.saveLocation(lastLocation);
      }
    );
  }

  render() {
    return (
      <Map
        google={this.props.google}
        zoom={17}
        onReady={this.fetchPlaces.bind(this)}
        initialCenter={this.props.discover.geoLoc}
        center={this.props.discover.geoLoc}
        onClick={this.onMapClicked.bind(this)}>
        <Marker
          title={this.props.discover.deliveryAddress || ''}
          // name={'Location'}
          draggable={true}
          onDragend={this.moveMarker.bind(this)}
          position={this.props.discover.geoLoc}
          name={'Current location'}
        />
      </Map>
    );
  }

  componentDidMount() {
    this.showMap();
  }

  // show map function
  showMap() {
    const self = this;
    if ('geolocation' in navigator) {
      if (f7.device.cordova) {
        document.addEventListener(
          'deviceready',
          self.onDeviceReady.bind(this),
          false
        );
      } else {
        self.onDeviceReady();
      }
    } else {
      f7.dialog.alert(
        `This device does not support geolocation. Please use the autocomplete on the input field`,
        'Location Error'
      );
    }
  }

  // handle map display when component loads
  onDeviceReady() {
    const self = this;

    // check if last loaded location is avaliable
    if (
      self.props.auth.isLoaded &&
      self.props.auth.isEmpty &&
      localStorage.getItem('lastLocation')
    ) {
      // un authenticated user
      const { deliveryAddress, geoLoc } = JSON.parse(
        localStorage.getItem('lastLocation')
      );

      self.props.updateState({
        deliveryAddress,
        disableButton: false,
      });

      self.props.dispatch({
        type: LOAD_DISCOVER,
        payload: {
          deliveryAddress,
          geoLoc,
        },
      });
    } else if (
      self.props.auth.isLoaded &&
      !self.props.auth.isEmpty &&
      self.props.profile.isLoaded &&
      self.props.profile.lastLocation
    ) {
      // authenticated user

      const { deliveryAddress, geoLoc } = self.props.profile.lastLocation;
      self.props.updateState({
        deliveryAddress,
        disableButton: false,
      });

      self.props.dispatch({
        type: LOAD_DISCOVER,
        payload: {
          deliveryAddress,
          geoLoc,
        },
      });
    } else {
      // Load real time location
      navigator.geolocation.getCurrentPosition(
        (position) => {
          self.props.dispatch({
            type: LOAD_DISCOVER,
            payload: {
              geoLoc: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
          });

          useGeoCode(
            {
              type: 'Address',
              data: {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              },
            },
            (error, address) => {
              if (error) {
                self.props.updateState({
                  deliveryAddress: '',
                  disableButton: false,
                });
                return self.props.dispatch({
                  type: LOAD_DISCOVER,
                  payload: {
                    deliveryAddress: '',
                  },
                });
              }

              self.props.updateState({
                deliveryAddress: address,
                disableButton: false,
              });

              self.props.dispatch({
                type: LOAD_DISCOVER,
                payload: {
                  deliveryAddress: address,
                },
              });

              const lastLocation = {
                deliveryAddress: address,
                geoLoc: {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude,
                },
              };

              self.props.saveLocation(lastLocation);
            }
          );
        },
        (error) => {
          const generalText = 'Please use the autocomplete on the input field';
          const text =
            error.code === 1
              ? `You have denied us access to your location. ${generalText}`
              : error.code === 2
              ? `An error occured while getting your geolocation. ${generalText}`
              : `Fetching location timed out. ${generalText}`;
          f7.dialog.alert(text, 'Location Error');
        },
        { maximumAge: 3000, timeout: 10000, enableHighAccuracy: true }
      );
    }
  }
}

const mapStateToProps = ({ discover }) => ({
  discover,
});
const enhance = compose(connect(mapStateToProps));

export default GoogleApiWrapper({
  apiKey: GOOGLE_MAP,
  language: 'en',
})(enhance(MapContainer));
